export const defaultControlLayer = 'DEFAULT';

export const perspectiveControlLayer = 'PERSPECTIVE';

export const cropControlLayer = 'CROP';
